import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { orderBy } from "lodash";
export default {
  data: function data() {
    return {
      landlordConversationList: [],
      // 联系房东会话列表
      tenantConversationList: [],
      // 房客咨询会话列表

      landlordConversationCount: 0,
      tenantConversationCount: 0
    };
  },
  watch: {
    "$route.query.id": function $routeQueryId() {
      this.getConversationList();
    }
  },
  mounted: function mounted() {
    this.getConversationList();
  },
  methods: {
    getConversationList: function getConversationList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, landlordConversationList, tenantConversationList;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$api.getConversationList({
                pn: 1,
                ps: 100,
                userId: _this.$route.query.userId
              });
            case 1:
              res = _context.v;
              landlordConversationList = [];
              tenantConversationList = [];
              res.data.list.forEach(function (item) {
                if (item.landlord) {
                  landlordConversationList.push(item);
                } else {
                  tenantConversationList.push(item);
                }
              });
              _this.landlordConversationCount = landlordConversationList.length;
              _this.tenantConversationCount = tenantConversationList.length;
              _this.landlordConversationList = orderBy(landlordConversationList, ["recordCount"], ["desc"]).splice(0, 5);
              _this.tenantConversationList = orderBy(tenantConversationList, ["recordCount"], ["desc"]).splice(0, 5);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    goChatRecord: function goChatRecord(row) {
      window.open("#/im/chat/record?userId=".concat(row.userId, "&otherId=").concat(row.otherId));
    }
  }
};